export default "__VITE_ASSET__DwiZkn5w__"